<template>
  <header>
    <div class="header-title">
      <router-link to="/">
        <h1>TEXT WALK</h1>
      </router-link>
    </div>
    <div>
      <btn-logout></btn-logout>
    </div>
  </header>
</template>

<script>
import BtnLogout from "@/components/BtnLogout";
export default {
  name: 'LayoutHeader',
  components: {BtnLogout},
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header{
  padding: 5px;
  background-color: #ddf2ff;
  width: 100%;
}
header div{
  display: inline-block;
}
header div:nth-child(1){
  width: 50%;
  margin-left: auto;
}
header div:nth-child(2){
  width: 50%;
  text-align: right;
}

div #burger{
  border: 1px solid #20a0ff;
  border-radius: 0.3rem;
  padding: 0.1rem 0.3rem;
  color: #20a0ff;
  height: 1rem;
}
h1 {
  font-size: 20px;
  color: #20a0ff;
  margin: 0rem 0rem;
}
a {
  text-decoration: none;
}

</style>
